<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    
    <g style="fill:none">
        <path d="M15.24 13.95c-.44-1.07-.99-2.06-1.42-2.59-.41-.5-1.17-.97-2.12-1.33-.9-.34-1.89-.53-2.69-.53s-1.79.19-2.69.53c-.96.36-1.71.83-2.12 1.33-.5.61-1.03 1.5-1.42 2.39-.35.79-.76 1.97-.76 3.21.01.18.06.36.14.51.09.17.21.31.34.39l.23.15h12.34l.27-.02.19-.13c.13-.09.25-.22.33-.38.08-.15.13-.33.15-.58 0-.97-.48-2.26-.76-2.95Z"
              style="fill:currentColor"/>
        <circle cx="9" cy="4" r="4" style="fill:currentColor"/>
    </g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    name: {
      type: String,
      required: false,
      default: 'SingleNeutral',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 18 18',
    },
  },
};
</script>

<style scoped>
  
</style>